import '../../App.css';
import '../../assets/css/admin.css';
import { Col, Row, Card, Breadcrumb, Badge, Table } from 'react-bootstrap';
import React, { useEffect, useState, useRef } from "react";
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import axios from 'axios';
import config from '../../config';
import { useAuth } from '../../context/AuthContext';
import { TbUsersMinus } from "react-icons/tb";
import { TbBeach } from "react-icons/tb"
import { PiUsersFourLight } from "react-icons/pi";
import { LiaHourglassHalfSolid } from "react-icons/lia";
import { Dialog } from 'primereact/dialog';
import { TabView, TabPanel } from 'primereact/tabview';
import Dash_evntcal from '../../components/Dash_evntcal';
import Brand_postcal from '../../components/Brand_postcal';
import { Sidebar } from 'primereact/sidebar';
import Meeting_notes from '../../components/Meeting_notes';
import noUserImg from '../../assets/images/no_user.png';
import { DateRangePicker } from "react-bootstrap-daterangepicker";
import "bootstrap-daterangepicker/daterangepicker.css";
import { getSocket } from '../../context/socket';
import View_edit_taskdetails from '../../modalPopup/View_edit_taskdetails';
import { VscFlame } from "react-icons/vsc";
import { PiFlagBannerFill } from "react-icons/pi";
import { Carousel } from 'primereact/carousel';
import { FaSkullCrossbones } from "react-icons/fa";
import { IoHandRightSharp } from "react-icons/io5";
import { CgFlagAlt } from "react-icons/cg";
import { Avatar } from 'primereact/avatar';
import { AvatarGroup } from 'primereact/avatargroup';
import { Tooltip } from 'primereact/tooltip';
const Hr_dash = () => {
    const { accessToken, userId } = useAuth();
    const [visible, setVisible] = useState(false);
    const [visible1, setVisible1] = useState(false);
    const [visible2, setVisible2] = useState(false);
    const [loading, setLoading] = useState(false);
    const [overtimeData, setOvertimeData] = useState([]);
    const [tasks, setTasks] = useState([]);
    const socket = getSocket();

    const [presentCount, setPresentCount] = useState(0);
    const [notCheckedInCount, setNotCheckedInCount] = useState(0);
    const [leaveCount, setLeaveCount] = useState(0);
    const [leaveUsers, setleaveUsers] = useState(0);
    const [overallEmployees, setOverallEmployees] = useState(0);
    const [notCheckedInUsers, setNotCheckedInUsers] = useState([]);

    const [taskSummary, setTaskSummary] = useState(null);
    const [visibleSidebar, setVisibleSidebar] = useState(false);
    const [sidebarTitle, setSidebarTitle] = useState("");
    const [selectedCards, setSelectedCards] = useState([]);
    const [rawCardData, setRawCardData] = useState({});
    const [employeetaskSummary, setemployeeTaskSummary] = useState(null);

    const [visibleRight, setVisibleRight] = useState(false);


    const [taggedComments, setTaggedComments] = useState([]);


    const [dateRange, setDateRange] = useState(() => {
        const range = localStorage.getItem("CommentsDateRange");
        if (range) {
            const parsedRange = JSON.parse(range);
            return {
                startDate: moment(parsedRange.startDate), // Convert back to moment object
                endDate: moment(parsedRange.endDate), // Convert back to moment object
            };
        }
        return {
            startDate: moment().startOf("week"),
            endDate: moment().endOf("week"),
        };
    });

    useEffect(() => {
        localStorage.setItem(
            "CommentsDateRange",
            JSON.stringify({
                startDate: dateRange.startDate.toISOString(), // Store as ISO string
                endDate: dateRange.endDate.toISOString(), // Store as ISO string
            })
        );
    }, [dateRange]);



    useEffect(() => {
        setLoading(true);

        socket.emit('fetchAllUrgentCards');

        socket.on('allUrgentCardsFetched', ({ success, data }) => {
            if (success) {
                setTasks(data);
            }
            setLoading(false);
        });

        return () => {
            socket.off('allUrgentCardsFetched');
        };
    }, []);


    useEffect(() => {
        socket.emit("sendTaskCards");

        socket.on("receiveTaskCardsByBrand", (data) => {
            const summary = {};

            Object.values(data).forEach((brandData) => {
                const brandName = brandData.brandName;

                summary[brandName] = {
                    Todo: brandData.toDo.length,
                    InProgress: brandData.onGoing.length,
                    Completed: brandData.completed.length,
                    missedDeadlines: brandData.missedDeadline.length,
                    Urgent: brandData.priorityTasks.length, // <-- Add this line
                    totalTasks: brandData.total
                };

            });

            setTaskSummary(summary);

            setRawCardData(data); // Save raw grouped cards
        });

        return () => {
            socket.off("receiveTaskCardsByBrand");
        };
    }, []);



    const handleTaskClick = (brandName, type) => {
        const brand = Object.values(rawCardData).find((b) => b.brandName === brandName);
        if (!brand) return;

        let cards = [];

        switch (type) {
            case "Todo":
                cards = brand.toDo;
                break;
            case "InProgress":
                cards = brand.onGoing;
                break;
            case "Completed":
                cards = brand.completed;
                break;
            case "Urgent":
                cards = brand.priorityTasks;
                break;
            case "missedDeadlines":
                cards = brand.missedDeadline;
                break;
            default:
                cards = [];
        }

        setSidebarTitle(`${brandName} - ${type}`);
        setSelectedCards(cards.map(c => c.card)); // unwrap the `card` object
        setVisibleSidebar(true);
    };




    // Fetch tagged comments
    const fetchTaggedComments = async () => {
        setLoading(true);
        try {
            const response = await axios.get(`${config.apiBASEURL}/CommentRoutes/tagged-comments`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                params: {
                    user_id: userId,
                    start_date: moment(dateRange.startDate).utc().startOf("day").toISOString(),
                    end_date: moment(dateRange.endDate).utc().endOf("day").toISOString(),
                },
            });

            if (response.data.success) {
                setTaggedComments(response.data.data);
            }
        } catch (err) {
            console.error('Error fetching tasks:', err);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTaggedComments();
    }, [dateRange, accessToken, userId]);

    // Handle date range change
    const handleDateRangeChange = (start, end) => {
        setDateRange({
            startDate: moment(start).local(),
            endDate: moment(end).local(),
        });
    };




    useEffect(() => {
        // Fetch data from the API
        const fetchData = async () => {
            try {
                const response = await fetch(`${config.apiBASEURL}/attendance/fetch-dashboard-attendance-summary`, {
                    headers: { Authorization: `Bearer ${accessToken}` },

                }); // Replace with your actual API endpoint
                const data = await response.json();

                // Update state
                setPresentCount(data.presentCount);
                setNotCheckedInCount(data.notCheckedInCount);
                setLeaveCount(data.leaveCount);
                setleaveUsers(data.leaveUsers);
                setOverallEmployees(data.totalUsers);
                setNotCheckedInUsers(data.notCheckedInUsers);
            } catch (error) {
                console.error('Error fetching attendance data:', error);
            }
        };

        fetchData();
    }, []);



    // Fetch the current attendance status on load
    useEffect(() => {
        const fetchOvertime = async () => {
            try {
                setLoading(true);
                const response = await axios.get(`${config.apiBASEURL}/overtimeRoutes/dashboardovertime`, {
                    headers: { Authorization: `Bearer ${accessToken}` },

                });
                setOvertimeData(response.data);
            } catch (error) {
                console.error('Error fetching attendance status:', error);
            } finally {
                setLoading(false);
            }
        };

        fetchOvertime();
    }, [accessToken]);



    useEffect(() => {
        setLoading(true);
        const fetchEmployeeTaskSummary = async () => {
            try {
                // Replace with your backend API URL
                const response = await axios.get(`${config.apiBASEURL}/projectRoutes/user-task-summary`, {
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });
                setemployeeTaskSummary(response.data.summary || {});
            } catch (err) {
                console.error('Error fetching employee task summary:', err);
                setLoading(false);
            }
        };
        fetchEmployeeTaskSummary();
    }, [accessToken]);





    const formatTime = (time) => {
        const [hours, minutes] = time.slice(0, 5).split(':').map(Number); // Get HH:mm and split
        const suffix = hours >= 12 ? 'PM' : 'AM'; // Determine AM/PM
        const adjustedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format
        return `${adjustedHours}:${minutes.toString().padStart(2, '0')} ${suffix}`; // Format time with AM/PM
    };



    const formatDate = (dateStr) => {
        if (!dateStr) return '';
        const date = new Date(dateStr);
        const options = { day: 'numeric', month: 'short' }; // e.g., "7 Apr"
        return date.toLocaleDateString('en-US', options);
    };

    const getDueDateClass = (dueDate) => {
        if (!dueDate) return "";

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const due = new Date(dueDate);
        due.setHours(0, 0, 0, 0);

        const diffDays = (due - today) / (1000 * 60 * 60 * 24);

        if (diffDays < 0) {
            return "bg-danger"; // Passed
        } else if (diffDays === 0) {
            return "bg-danger"; // Today
        } else if (diffDays === 1) {
            return "bg-warning"; // Tomorrow
        } else {
            return "bg-success"; // Future
        }
    };

    /*--------------pjRep----------------*/

    const sectionRef = useRef(null);

    const scrollToSection = (event) => {
        event.preventDefault(); // Prevent default anchor behavior

        if (sectionRef.current) {
            sectionRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
        }
    };

    /*--------------------taskSlid----------------*/


    const responsiveOptions = [
        {
            breakpoint: '1400px',
            numVisible: 2,
            numScroll: 1
        },
        {
            breakpoint: '991px',
            numVisible: 1,
            numScroll: 1
        },
        {
            breakpoint: '575px',
            numVisible: 1,
            numScroll: 1
        }
    ];



    const productTemplate = (entry) => {
        const card = entry;

        return (
            <Card className="m-2 p-3 shadow-sm dashNewtask">
                <Card.Body className='p-0' onClick={() => showDialog('top-right', card.card_id, card.board_id)} style={{ cursor: 'pointer' }}>
                    <ul className="list-unstyled mb-0">
                        <li className="mb-3">
                            <p>
                                <span>Brand:</span> {card?.list?.board?.brand?.brand_name || 'No brand'}
                                {card?.priority === 'Urgent' && (
                                    <small className="misses_image2 ms-2 text-danger">
                                        <PiFlagBannerFill />
                                    </small>
                                )}
                            </p>
                            {card?.missed_deadline && (
                                <div className="misses_image">
                                    <VscFlame />
                                </div>
                            )}
                            <p>
                                <span>Project:</span> {card?.list?.board?.project?.project_name || 'No project'}
                            </p>
                            <p>
                                <span>Board:</span> {card?.list?.board?.name || 'NA'}
                            </p>
                            <p>
                                <span>Task:</span> {card?.title || 'No task'}
                            </p>
                            <p className='d-flex'>
                                <span
                                    style={{
                                        fontSize: '12px',
                                        backgroundColor: card?.list?.color_code || '#ccc',
                                        color: '#fff',
                                        padding: '0px 5px',
                                        borderRadius: '4px',
                                        display: 'inline-block'
                                    }}
                                >
                                    {card?.list?.name}
                                </span>
                                <small className={`text-white rounded ms-2 ${getDueDateClass(card?.due_date)}`} style={{ fontSize: '11px', padding: '2px 5px' }}>
                                    <i className="pi pi-calendar" style={{ fontSize: '11px' }}></i>
                                    {" "}{formatDate(card?.createdAt)} - {formatDate(card?.due_date)}
                                </small>
                            </p>
                        </li>
                    </ul>
                </Card.Body>
                <Card.Footer className="d-flex justify-content-end p-0 m-0 border-0">
                    <AvatarGroup>
                        {card.members.map((member) => {
                            const fullName = `${member.first_name} ${member.last_name}`;
                            return (
                                <React.Fragment key={member.user_id}>
                                    <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                    <Avatar
                                        id={`avatar-${member.user_id}`}
                                        image={member.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png"}
                                        shape="circle"

                                    />
                                </React.Fragment>
                            );
                        })}
                    </AvatarGroup>
                </Card.Footer>
            </Card>
        );
    };

 const [visible3, setVisible3] = useState(false);
    const [position, setPosition] = useState('top-right');
    const [selectedTaskId, setSelectedTaskId] = useState(null);
    const [board_id, setBoardId] = useState(null); // Add this
    const showDialog = (position, taskId, boardId) => {
        setPosition(position);
        setSelectedTaskId(taskId);
        setBoardId(boardId);
        setVisible3(true);
    };

    // Handle dialog close
    const handleDialogClose = () => {
        if (!visible3) return;
        setVisible3(false);
    };

    return (
        <>
            <Row className='body_content'>
                <Row className='mx-0'>
                    <Col md={12} lg={12} className='mb-4 d-flex justify-content-between align-items-center'>
                        <Breadcrumb>
                            <Breadcrumb.Item active>Dashboard</Breadcrumb.Item>
                        </Breadcrumb>
                        <Button
                            label='Meeting Notes'
                            icon='pi pi-headphones'
                            severity='primary'
                            className='border-0 py-2'
                            onClick={() => setVisibleRight(true)}
                        />
                    </Col>
                    <Col md={12} lg={12} className='mb-4'>
                        <Card>
                            <TabView>
                                <TabPanel header="Event Calendar">
                                    <Dash_evntcal />
                                </TabPanel>
                                <TabPanel header="Brand Calander">
                                    <Brand_postcal />
                                </TabPanel>

                            </TabView>
                        </Card>

                    </Col>
                    <Col md={'12'} lg={'6'} className='mb-4'>
                        <Card>
                            <Card.Body>
                                <Row className='justify-content-between'>
                                    <Col md={'6'} lg={'6'} className='dashboard_card'>
                                        <Card className='shadow-0 mb-3'>
                                            <Card.Header>
                                                <div className="d-flex justify-content-between">
                                                    <div>
                                                        <span className="d-block">Present <sub className='text-primary'>(Today)</sub></span>
                                                    </div>
                                                    <div className='hrshortdata'>
                                                        <span><PiUsersFourLight /></span>
                                                    </div>
                                                </div>
                                            </Card.Header>
                                            <Card.Body className='pt-3'>
                                                <Card.Title>{presentCount}</Card.Title>
                                                <Card.Text>
                                                    <span>Overall Employees {overallEmployees}</span>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                    <Col md={'6'} lg={'6'} className='dashboard_card'>
                                        <Link onClick={() => setVisible(true)}>
                                            <Card className='shadow-0 mb-3'>
                                                <Card.Header>
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <span className="d-block">Not Checked-In <sub className='text-primary'>(Today)</sub></span>
                                                        </div>
                                                        <div className='hrshortdata'>
                                                            <span><TbUsersMinus /></span>
                                                        </div>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body className='pt-3'>
                                                    <Card.Title>{notCheckedInCount}</Card.Title>
                                                    <Card.Text>
                                                        <span>Overall Employees {overallEmployees}</span>
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col md={'6'} lg={'6'} className='dashboard_card'>
                                        <Link onClick={() => setVisible1(true)}>
                                            <Card className='shadow-0 mb-0'>
                                                <Card.Header>
                                                    <div className="d-flex justify-content-between">
                                                        <div>
                                                            <span className="d-block">Approved Leave <sub className='text-primary'>(Today)</sub></span>
                                                        </div>
                                                        <div className='hrshortdata'>
                                                            <span><TbUsersMinus /></span>
                                                        </div>
                                                    </div>
                                                </Card.Header>
                                                <Card.Body className='pt-3'>
                                                    <Card.Title>{leaveCount}</Card.Title>
                                                    <Card.Text>
                                                        <span>Overall Employees {overallEmployees}</span>
                                                    </Card.Text>
                                                </Card.Body>
                                            </Card>
                                        </Link>
                                    </Col>
                                    <Col md={'6'} lg={'6'} className='dashboard_card'>
                                        <Card className='shadow-0 mb-0'>
                                            <Card.Header>
                                                <div className="d-flex justify-content-between">
                                                    <div className='headerdashTitle'>
                                                        <span className="d-block">Half Day <sub className='text-primary'>(Today)</sub></span>
                                                    </div>
                                                    <div className='hrshortdata'>
                                                        <span><LiaHourglassHalfSolid /></span>
                                                    </div>
                                                </div>
                                            </Card.Header>
                                            <Card.Body className='pt-3'>
                                                <Card.Title>0</Card.Title>
                                                <Card.Text>
                                                    <span>Overall Employees {overallEmployees}</span>
                                                </Card.Text>
                                            </Card.Body>
                                        </Card>
                                    </Col>
                                </Row>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* <Col lg={6} className="mb-3">
                        <Card className="h-100">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <h6 className="mb-0">
                                    Task Comments
                                    {taggedComments.length > 0 && (
                                        <sup>
                                            <Badge className="bg-danger ms-1">{taggedComments.length}</Badge>
                                        </sup>
                                    )}
                                </h6>
                                <div>
                                    <DateRangePicker
                                        initialSettings={{
                                            startDate: dateRange.startDate,
                                            endDate: dateRange.endDate,
                                            locale: { format: "DD/MM/YYYY" },
                                            ranges: {
                                                Today: [moment(), moment()],
                                                Yesterday: [moment().subtract(1, "days"), moment().subtract(1, "days")],
                                                "Last 7 Days": [moment().subtract(6, "days"), moment()],
                                            },
                                        }}
                                        onCallback={handleDateRangeChange}
                                    >
                                        <input
                                            type="text"
                                            className="dashDate"
                                            placeholder="Select Date Range"
                                        />
                                    </DateRangePicker>
                                </div>
                            </Card.Header>
                            <Card.Body className="table-scroll">
                                {loading ? (
                                    <p>Loading comments...</p>
                                ) : taggedComments.length === 0 ? (
                                    <p>No tagged comments found for the selected date range.</p>
                                ) : (
                                    <ul className="dashcomments">
                                        {taggedComments.map((comment) => (
                                            <li key={comment.comment_id}>
                                                <div className="d-flex align-items-start">
                                                    <div className="dsh_img">
                                                        <img src={comment.user.profileImage || noUserImg} alt="User" />
                                                    </div>
                                                    <div className="dsh_txt">
                                                        <h6>
                                                            {comment.user.name} &nbsp; | &nbsp;
                                                            <small className="text-muted">
                                                                {moment(comment.createdAt).format("DD MMM YYYY [at] hh:mm A")}
                                                            </small>
                                                            &nbsp; | &nbsp;
                                                            <small className="text-success">
                                                                {comment.comment_type}
                                                            </small>

                                                        </h6>
                                                        <p>{comment.comment_text}</p>
                                                        <Link to={`/Graphe/dashboard/view_task/${comment.task_id}`}>
                                                            View... <i className="pi pi-angle-right"></i>
                                                        </Link>
                                                    </div>
                                                </div>
                                            </li>
                                        ))}
                                    </ul>
                                )}
                            </Card.Body>
                        </Card>
                    </Col> */}

                    <Col md={'12'} lg={'6'}>
                        <Card className="p-0">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <b>
                                    Priority Tasks <sub className="text-primary">(This Week)</sub>
                                </b>
                                <span>
                                    Total: <b className="ms-1">{tasks.length}</b>
                                </span>
                            </Card.Header>
                            <Card.Body className="table-scroll px-0 pb-2 text-start">
                                {loading ? (
                                    <div>Loading...</div>
                                ) : tasks.length === 0 ? (
                                    <div className="text-danger">No tasks available for this week.</div>
                                ) : (

                                    <Carousel
                                        value={tasks}
                                        numVisible={2}
                                        numScroll={1}
                                        responsiveOptions={responsiveOptions}
                                        itemTemplate={productTemplate}
                                        circular
                                        autoplayInterval={5000}
                                    />


                                )}
                            </Card.Body>
                        </Card>
                    </Col>


                    {/* <Col md="12" lg="12" className="dashboard_card">
                        <Card className="emp_list_card p-0">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <b>
                                    Task Overview <sub className="text-primary">(This Month)</sub>
                                </b>
                            </Card.Header>
                            <Card.Body className="table-scroll">
                                <div className="responsive">
                                    <Table hover size="sm" bordered striped>

                                        <tbody>
                                            {taskSummary && Object.entries(taskSummary).length > 0 ? (
                                                Object.entries(taskSummary).map(([brandName, data]) => (
                                                    <tr key={brandName}>
                                                        <td className="table-info" style={{ width: '200px' }}>{brandName}</td>
                                                        <td>
                                                            <ul className='prolistdata'>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        Todo:
                                                                    </small>
                                                                    {data.Todo}
                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        In Progress:
                                                                    </small>
                                                                    {data.InProgress}
                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        In Review:
                                                                    </small>
                                                                    {data.InReview}
                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        In Changes:
                                                                    </small>
                                                                    {data.InChanges}

                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        Completed:
                                                                    </small>
                                                                    {data.Completed}
                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        Missing Deadlines:
                                                                    </small>
                                                                    {data.missedDeadlines}
                                                                </li>
                                                                <li>
                                                                    <small className="text-muted">
                                                                        Total Tasks:
                                                                    </small>
                                                                    {data.totalTasks}
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col> */}


                    <Col md="12" lg="12" className="dashboard_card shado-0">
                        <Card className="p-0">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <b>
                                    Task Overview <sub className="text-primary">(This Month)</sub>
                                </b>
                            </Card.Header>
                            <Card.Body className="table-scroll">
                                <div className="responsive">
                                    <Table size="sm" striped border-0>
                                        <tbody>
                                            {taskSummary && Object.entries(taskSummary).length > 0 ? (
                                                Object.entries(taskSummary).map(([brandName, data]) => (
                                                    <tr key={brandName}>
                                                        <td className="table-info text-center" style={{ width: '200px' }}>
                                                            {brandName}
                                                        </td>
                                                        <td>
                                                            <ul className='prolistdata'>
                                                                <li onClick={() => handleTaskClick(brandName, 'Todo')} className="clickable text-info">
                                                                    <small className="text-info">Todo</small>
                                                                    {data.Todo}
                                                                </li>
                                                                <li onClick={() => handleTaskClick(brandName, 'InProgress')} className="clickable text-warning">
                                                                    <small className="text-warning">Being Worked On</small>
                                                                    {data.InProgress}
                                                                </li>
                                                                <li onClick={() => handleTaskClick(brandName, 'Completed')} className="clickable text-success">
                                                                    <small className="text-success">Completed</small>
                                                                    {data.Completed}
                                                                </li>
                                                                <li onClick={() => handleTaskClick(brandName, 'Urgent')} className="clickable text-danger">
                                                                    <small className="text-danger">Urgent</small>
                                                                    {data.Urgent}
                                                                </li>
                                                                <li onClick={() => handleTaskClick(brandName, 'missedDeadlines')} className="clickable" style={{ color: "rgb(156, 39, 176)" }}>
                                                                    <small style={{ color: "rgb(156, 39, 176)" }}>Missed Deadlines</small>
                                                                    {data.missedDeadlines}
                                                                </li>
                                                                <li className='tex-dark'>

                                                                    <small><b>Total Tasks</b></small>
                                                                    <b>{data.totalTasks}</b>
                                                                </li>
                                                            </ul>
                                                        </td>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">No data available</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>



                    {/* <Col md={'12'} lg={'12'} className="dashboard_card">
                        <Card className="emp_list_card p-0">
                            <Card.Header className="d-flex justify-content-between align-items-center">
                                <b>
                                    Employees Project Report <sub className="text-primary">(This Month)</sub>
                                </b>
                            </Card.Header>
                            <Card.Body className="table-scroll">
                                <div className="responsive">
                                    <Table hover size="sm" bordered striped>
                                        <thead className="sticky-top" style={{ top: '-20px' }}>
                                            <tr className="table-light">
                                                <th className="table-info">Name</th>
                                                <th>Todo</th>
                                                <th>In Progress</th>
                                                <th>In Review</th>
                                                <th>In Changes</th>
                                                <th>Completed</th>
                                                <th>Missed Deadlines</th>
                                                <th>On Time</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {employeetaskSummary && Object.entries(employeetaskSummary).length > 0 ? (
                                                Object.entries(employeetaskSummary).map(([name, data]) => (
                                                    <tr key={name}>
                                                        <td className="table-info">{name}</td>
                                                        <td>{data.Todo || 0}</td>
                                                        <td>{data.InProgress || 0}</td>
                                                        <td>{data.InReview || 0}</td>
                                                        <td>{data.InChanges || 0}</td>
                                                        <td>{data.Completed || 0}</td>
                                                        <td>{data.missedDeadlines || 0}</td>
                                                        <th>{data.totalTasks || data.onTimeTasks || 0}</th>
                                                    </tr>
                                                ))
                                            ) : (
                                                <tr>
                                                    <td colSpan="8" className="text-center">
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col> */}



                    <Col md={'12'} lg={'12'} className='dashboard_secondcard mb-4'>
                        <Card>
                            <Card.Header className='mb-0'>
                                <div className="d-flex justify-content-between">
                                    <div>
                                        <span className="d-block">Over Time <sub className='text-primary'>(This Week)</sub></span>
                                    </div>
                                    <div>
                                        <Link to="/Graphe/dashboard/overtime">
                                            <Button
                                                label="View All"
                                                severity="info"
                                                outlined
                                                className="border-0 p-0"
                                            />
                                        </Link>
                                    </div>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Table responsive bordered size="sm" hover className='taskover'>
                                    <thead>
                                        <tr>
                                            <th scope='col'>Name</th>
                                            <th scope='col'>Date</th>
                                            <th scope='col'>Start Time</th>
                                            <th scope='col'>End Time</th>
                                            <th scope='col'>OT Hours</th>
                                            <th style={{ width: '100px' }}>Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {overtimeData.Pending && overtimeData.Pending.length > 0 ? (
                                            overtimeData.Pending.map((overtime) => (
                                                <tr key={overtime.overtime_id}>
                                                    <td> <img
                                                        src={overtime.requester.profileImage?.image_url || noUserImg}
                                                        alt="Profile"
                                                        className="rounded-circle me-2"
                                                        style={{ width: '35px', height: '35px', objectFit: 'cover' }}
                                                    />
                                                        {`${overtime.requester.first_name} ${overtime.requester.last_name}`}</td>
                                                    <td>{new Date(overtime.ovetime_date).toLocaleDateString('en-GB')}</td>
                                                    <td>{formatTime(overtime.start_time)}</td> {/* Format start_time */}
                                                    <td>{formatTime(overtime.end_time)}</td>   {/* Format end_time */}
                                                    <td>{(overtime.total_time / 60).toFixed(1)} hrs</td>

                                                    <td>
                                                        <Badge className='bg-warning'>
                                                            {overtime.status}
                                                        </Badge>
                                                    </td>
                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    No overtime data available for this week.
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                            </Card.Body>
                        </Card>
                    </Col>


                    <Dialog header="Today Not Checked-IN" visible={visible} style={{ width: '340px' }} onHide={() => setVisible(false)}>
                        <Card className="p-0 shadow-0">
                            <Card.Body className="scrollbody p-0">
                                <Card.Title>
                                    {notCheckedInUsers.map(user => (
                                        <div className="leave-info-box pt-4" key={user.user_id}>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={user.profileImage?.image_url || noUserImg}
                                                    alt=""
                                                    style={{ width: '34px', height: '34px' }}
                                                    className="rounded-circle"
                                                />
                                                <div className="ms-3">
                                                    <p className="fw-bold mb-1 text-sm">{user.first_name} {user.last_name}</p>
                                                    <p className="text-muted mt-2 mb-0 text-sm">
                                                        <i className="pi pi-phone"></i> {user.userDetails?.phone || 'N/A'}
                                                    </p>
                                                    <div style={{ position: 'absolute', top: '-8px', left: '-3px' }}>
                                                        <Badge color="info" pill className="text-sm">
                                                            Not Checked In
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Card.Title>
                            </Card.Body>
                        </Card>
                    </Dialog>

                    <Dialog header="Today On Leave" visible={visible1} style={{ width: '340px' }} onHide={() => setVisible1(false)}>
                        <Card className="p-0 shadow-0">
                            <Card.Body className="scrollbody p-0">
                                <Card.Title>
                                    {(Array.isArray(leaveUsers) ? leaveUsers : []).map(user => (
                                        <div className="leave-info-box pt-4" key={user.user_id}>
                                            <div className="d-flex align-items-center">
                                                <img
                                                    src={user.profileImage?.image_url || noUserImg}
                                                    alt=""
                                                    style={{ width: '34px', height: '34px' }}
                                                    className="rounded-circle"
                                                />
                                                <div className="ms-3">
                                                    <p className="fw-bold mb-1 text-sm">{user.first_name} {user.last_name}</p>
                                                    <p className="text-muted mt-2 mb-0 text-sm">
                                                        <i className="pi pi-phone"></i> {user.userDetails?.phone || 'N/A'}
                                                    </p>
                                                    <div style={{ position: 'absolute', top: '-8px', left: '-3px' }}>
                                                        <Badge color="success" pill className="text-sm">
                                                            Leave Today
                                                        </Badge>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </Card.Title>
                            </Card.Body>
                        </Card>
                    </Dialog>
                </Row>
            </Row>
            <Sidebar visible={visibleRight} position="right" onHide={() => setVisibleRight(false)} style={{ width: '550px' }} className='meetingNotes'>
                <Meeting_notes />
            </Sidebar>

            <Sidebar
                visible={visibleSidebar}
                position="right"
                onHide={() => setVisibleSidebar(false)}
                header={sidebarTitle}
                style={{ width: '30rem' }}
                 className="KanbanDialog"
            >
                {selectedCards.length > 0 ? (
                    <ul className="list-group">
                        {selectedCards.map((task) => (
                            <li key={task.card_id} className="list-group-item" onClick={() => showDialog('top-right', task.card_id, task.board_id)} style={{ cursor: 'pointer' }}>
                                <div
                                    className={`board-task 
                                             ${task.missed_deadline ? "task-red example-1" : "task-green"} 
                                            ${task.priority === "Urgent" ? "example-1" : ""}`}
                                // onClick={() => onClick(task.id)}
                                >
                                    <div className="d-flex justify-content-end align-items-center mb-3">
                                        <Badge
                                            className={`badge ${task.priority === "Urgent" || task.priority === "High"
                                                ? "bg-danger"
                                                : task.priority === "Medium"
                                                    ? "bg-warning"
                                                    : task.priority === "Low"
                                                        ? "bg-info"
                                                        : "bg-secondary"
                                                }`}
                                        >
                                            {task.priority}
                                        </Badge>

                                        {task.on_hold && (
                                            <div className="ms-2" style={{ position: "relative" }}>
                                                <IoHandRightSharp
                                                    data-pr-tooltip="Task Hold"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{ fontSize: "18px", color: "#f97316" }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </div>
                                        )}

                                        {task.missed_deadline && (
                                            <div className="ms-2" style={{ position: "relative" }}>
                                                <FaSkullCrossbones
                                                    data-pr-tooltip="Deadline Missed"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{ fontSize: "18px", color: "#ff63a5" }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </div>
                                        )}

                                        {task.priority === "Urgent" && (
                                            <div className="ms-2" style={{ position: "relative" }}>
                                                <CgFlagAlt
                                                    data-pr-tooltip="Priority Task"
                                                    data-pr-position="top"
                                                    className="missed-deadline-icon example-1"
                                                    style={{ fontSize: "18px", color: "#ff63a5" }}
                                                />
                                                <Tooltip target=".missed-deadline-icon" />
                                            </div>
                                        )}
                                    </div>

                                    <p className="mb-0">
                                        <small>
                                            <b>Task Name:</b> {task.title}
                                        </small>
                                    </p>
                                    <p className="mb-0 text-muted">
                                        <small>
                                            <b>Task Type:</b> {task.task_type}
                                        </small>
                                    </p>

                                    <div className="d-flex justify-content-between align-items-center border-top mt-2 pt-2">
                                        <small
                                            className={`text-white px-2 py-1 rounded badge ${getDueDateClass(task?.due_date)}`}
                                            style={{ fontSize: "12px" }}
                                        >
                                            <i className="pi pi-calendar text-white me-1" style={{ fontSize: "12px" }}></i> {formatDate(task.createdAt)} - {formatDate(task.due_date)}
                                        </small>

                                        <AvatarGroup>
                                            {task.members.map((member) => {
                                                const fullName = `${member.first_name} ${member.last_name}`;
                                                return (
                                                    <React.Fragment key={member.user_id}>
                                                        <Tooltip target={`#avatar-${member.user_id}`} content={fullName} />
                                                        <Avatar
                                                            id={`avatar-${member.user_id}`}
                                                            image={member.profileImage?.image_url || "https://primefaces.org/cdn/primereact/images/avatar/xuxuefeng.png"}
                                                            shape="circle"

                                                        />
                                                    </React.Fragment>
                                                );
                                            })}

                                        </AvatarGroup>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                ) : (
                    <p>No tasks available.</p>
                )}
            </Sidebar>
            <Dialog
                visible={visible3}
                position={position}
                style={{ width: '1000px', margin: '0', borderRadius: '0', height: '100%' }}
                onHide={handleDialogClose}
                draggable={false}
                resizable={false}
                className="KanbanDialog"
            >
                <View_edit_taskdetails taskId={selectedTaskId} boardId={board_id} onClose={handleDialogClose} />
            </Dialog>
        </>

    )
};

export default Hr_dash;